import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { OnboardingModule } from "@webapp/shared/components/onboarding/onboarding.module";
import { UiRadioModule } from "@webapp/ui/radio/radio.module";
import { WhiteboardsUserSettingsService } from "@webapp/whiteboards/services/whiteboards-user-settings.service";
import { ProfileThemeComponent } from "./components/profile-theme.component";

@NgModule({
  imports: [CommonModule, FormsModule, UiRadioModule, OnboardingModule, LocalizationModule],
  declarations: [ProfileThemeComponent],
  providers: [WhiteboardsUserSettingsService],
})
export class UserProfileModule {}
